import { Button, Dropdown, Flex, Skeleton } from 'antd';
import { useContext, useEffect, useState } from 'react';
import More from 'src/assets/icons/more2.png';
import Icon from 'src/components/v2/Icon';
import { IFilePath } from 'src/types/helpdesk/topic.type';
import MessageImageContainer from '../Message/MessageImage/MessageImageContainer';
import './Attachment.scss';
import useDownload from 'src/hooks/useDownload';
import { TopicContext } from 'src/contexts/topic.context';
import { scrollToReply } from 'src/utils/utils';
import { useChatStore } from 'src/stores/chatStore';
import { useParams } from 'react-router-dom';

type Props = {
  images: IFilePath[];
  loading: boolean;
};

const LIMIT = 8;

export default function TopicAttachmentMedia({ images: imagesData, loading }: Props) {
  const [images, setImages] = useState<IFilePath[]>([]);
  const [isShow, setIsShow] = useState<boolean>(false);
  const download = useDownload();
  const { setPage } = useContext(TopicContext);
  const { id } = useParams();
  const rooms = useChatStore((state) => state.rooms);
  const messages = id ? rooms[id]?.allMessages : [];

  useEffect(() => {
    if (imagesData && !isShow) {
      setImages(imagesData.slice(0, LIMIT));
    } else {
      setImages(imagesData);
    }
  }, [imagesData, isShow]);

  const handleShowAll = () => {
    setImages(imagesData);
    setIsShow(true);
  };
  const handleShowLess = () => {
    setImages(imagesData.slice(0, LIMIT));
    setIsShow(false);
  };
  const handleDownload = (image: IFilePath) => {
    download.download(image as IFilePath);
  };

  const handleScrollToOrigin = (topicDetailId: string) => {
    const index = messages?.findIndex((x) => x?.id === topicDetailId);
    const pageOfIndex = Math.ceil((index || 0) / 10);
    setPage((prev) => {
      if (pageOfIndex > prev) {
        return pageOfIndex;
      }
      return prev;
    });

    scrollToReply(String(topicDetailId), 'center');
  };

  return (
    <Flex vertical gap={16}>
      <div className='media-list'>
        {!!id &&
          images.map((image) =>
            loading ? (
              <Skeleton.Avatar active size={65} shape='square' key={image.id} />
            ) : (
              <div className='media-item' key={image.id}>
                <Dropdown
                  menu={{
                    items: [
                      {
                        key: '1',
                        label: <li onClick={() => handleScrollToOrigin(image.topicDetailId)}>Xem tin nhắn gốc</li>
                      },
                      {
                        key: '2',
                        label: <li onClick={() => handleDownload(image)}>Tải về máy</li>
                      }
                    ]
                  }}
                  trigger={['click']}
                  placement='top'
                >
                  <Button className='media-action' size='small' icon={<Icon url={More} size={15} />} />
                </Dropdown>
                <MessageImageContainer
                  topicId={id}
                  file={image as IFilePath}
                  key={image.id}
                  className='image-wrapper'
                  isThumbnail={true}
                />
              </div>
            )
          )}
      </div>
      {imagesData.length > LIMIT &&
        (!isShow ? (
          <Button block onClick={handleShowAll} className='btn-show'>
            Xem tất cả
          </Button>
        ) : (
          <Button block onClick={handleShowLess} className='btn-show'>
            Thu gọn
          </Button>
        ))}
    </Flex>
  );
}
